import styles from "./InformationFormsStyle.module.scss";
import NameField from "../ReusableComponent/NameFields";
import FullAddressField from "../ReusableComponent/FullAddress";
import AddressField from "../ReusableComponent/AddressField";
import ContactsFields from "../ReusableComponent/ContactsFields";
import FormButtons from "./FormButtons";
import React, { useState, useRef } from "react";
import { useEffect } from "react";
import { baseUrl } from "../../common/constants";
import { toast } from "react-toastify";
import axios from "axios";
import { mainContext } from "../../context/context";
import _axios from "../../utils/api/_axios";
import { Content } from "antd/es/layout/layout";
import {Checkbox, Col, Form, Input, Radio, Row, Select, Typography } from "antd";
import { Option } from "antd/es/mentions";
import { getAdminToken } from "../../utils/helpers";
import { useParams } from "react-router-dom";
import { generatePtientSchema, validateField } from "./Validations/FormsValidations";
import { US_STATES } from "../../constants/states";
import { formatPhoneNumber } from '../../utils/helpers/phoneFormatter';

const PatientForm = () => {
  const token = getAdminToken()
  const currentLocation = window.location.pathname
  const PatientSchema = generatePtientSchema(currentLocation)
  const { currentTab, activeTab, formDataValues, getFormData,errors, setErrors } = React.useContext(mainContext)
  const { id } = useParams();
  const route = `/new-entry/details/${id}`
  const [isDisable,setIsDisable] = useState(false)
  const formRef = useRef(null);

  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    claimNumber: "",
    wcbNumber: "",
    dateOfInjury: "",
    injury: "",
    isRush: false,
    dateOfBirth: "",
    gender: "",
    feet: "",
    inches: "",
    weight: "",
    phone1: "",
    mobile: "",
    phone3: "",
    phone4: "",
    alternatePhone: "",
    alternateDescription: "",
    isTranslationRequired:false,
    isTransportationRequired:false,
    email: "",
    patient_address1: "",
    patient_address2: "",
    patient_city: "",
    patient_state: "",
    patient_zip: "",
    language: "",
    preferredLanguage: "",
    name:"",
    personEmail:"",
    phone:"",
    ...(token ? null : { height: { feet: "", inches: "" } })
  });
  const [searchedPatientsResults, setSearchedPatientsResults] = useState([]);
  const [searchPatientText, setSearchedPatientText] = useState("");
  const [selectedPatient, setSelectedPatient] = useState(null); 

  const inputChangeHandler = (event) => {
    const { name, value } = event.target;
    let updatedValue = ""
    setFormValues({ ...formValues, [name]: value });
    const errorMessage = validateField(name, value, PatientSchema);
    setErrors({ ...errors, [name]: errorMessage });
  
    getFormData({
      ...formDataValues,
      patientInfo: {
        ...formDataValues?.patientInfo,
        [name]: name === "language" ? updatedValue : value
      }
    });
  };

  const inputChangeHandlerForSelect = (name,value) => {
  let updatedValue = ""
    setFormValues({ ...formValues, [name]: value });
  
    const errorMessage = validateField(name, value, PatientSchema);
    setErrors({ ...errors, [name]: errorMessage });
  
    getFormData({
      ...formDataValues,
      patientInfo: {
        ...formDataValues?.patientInfo,
        [name]: name === "language" ? updatedValue : value
      }
    });
  };

  const CheckboxChangeHandler = (fieldName, event) => {
    const { name, value } = event.target;
    let updatedValue = ""
    setFormValues({ ...formValues, [fieldName]: !value });
    getFormData({
      ...formDataValues,
      patientInfo: {
        ...formDataValues?.patientInfo,
        [name]: name === "language" ? updatedValue : !value
      }
    });
  };

  const [selectedRadio, setSelectedRadio] = useState("");
  const HandleChangeValue = (e) => {
    setSelectedRadio(e.target.value);
    setFormValues({ ...formValues, language: e.target.value });
    const errorMessage = validateField("language", e.target.value, PatientSchema);
    setErrors({ ...errors, ["language"]: errorMessage });
    getFormData({
      ...formDataValues,
      patientInfo: {
        ...formDataValues?.patientInfo,
        language : e.target.value
      }
    });
  };

  const [message, setMessage] = useState("");
  const map = (formValues) => {
    const m =  {
      patientId: formValues.patientId,
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      claimNumber: formValues.claimNumber,
      wcbNumber: formValues.wcbNumber,
      dateOfInjury: formValues.dateOfInjury,
      isTranslationRequired: formValues.isTranslationRequired,
      isTransportationRequired: formValues.isTransportationRequired,
      injury: formValues.injury,
      isRush: formValues.isRush,
      dateOfBirth: formValues.dateOfBirth,
      gender: formValues.gender,
      height: {
        feet: formValues.feet,
        inches: formValues.inches,
      },
      weight: formValues.weight,
      phone1: formValues.phone1,
      mobile: formValues.mobile,
      workPhone: formValues.phone3,
      ext: formValues.phone4,
      alternatePhone: formValues.alternatePhone,
      alternateDescription: formValues.alternateDescription,
      email: formValues.email,
      patient_address1: formValues.patient_address1,
      patient_address2: formValues.patient_address2,
      patient_city: formValues.patient_city,
      patient_state: formValues.patient_state,
      patient_zip: formValues.patient_zip,
      languages: [
        formValues.language == "prefers"
          ? formValues.preferredLanguage
          : formValues.language,
      ],
    };

    if (!token) {
      m.height = {
        feet: formValues.feet,
        inches: formValues.inches,
      };
      m.insuranceSelectValue = formValues.insuranceSelectValue;
    }

    return m;
  };

  const handlePatientSelect = async (patientId) => {
    try {
      const patient = await fetchInitial(patientId);
      if (patient) {
        setSelectedPatient(patient);
        setPatientValues({ ...patient });
        setSearchedPatientsResults([]);
        setSearchedPatientText("");
      }
    } catch (error) {
      toast.error("Error fetching patient details");
    }
  };
  

  const handleSearchPatientTextChange = async (value) => {
    setSearchedPatientText(value);
    try {
      const response = await _axios.get(`${baseUrl}/patients/search?q=${value}`);
      if (response?.data?.payload?.length) {
        setSearchedPatientsResults(
          response.data.payload.map((patientInfo) => ({
            label: `${patientInfo?.firstName || ""} ${patientInfo?.lastName || ""
              } ${patientInfo?.email}`,
              _id: patientInfo?._id, claimNumber: patientInfo?.claimNumber
          }))
        );
      } else {
        setSearchedPatientsResults([]);
      }
    } catch (error) {
      toast("Unable to fetch patient details", {
        type: "error",
        autoClose: 3000,
      });
    }
  };

  let handleSubmit = async (event) => {
    event.preventDefault();
    setIsDisable(true);
    let url = `${baseUrl}/patients`;
    let method = "POST";
    const { error } = PatientSchema.validate(formValues, { abortEarly: false });
  
    if (error) {
      const errorMessages = error.details.reduce((acc, detail) => {
        acc[detail.path[0]] = detail.message;
        return acc;
      }, {});
      setErrors(errorMessages);
      setIsDisable(false);
    } else {
      setErrors({});
      try {
        let res = await axios({
          url: url,
          method: method,
          data: map(formValues),
          headers: {
              'Content-Type': 'application/json',
          },
          cache: 'no-cache'
        });
  
        if (res.status === 200 || res.status === 201) {
          sessionStorage.clear();
          sessionStorage.setItem("patientId", res.data.payload?._id);
          sessionStorage.setItem("claimId", res.data.payload.claimId);
          toast("Successfully saved patient.", {
            type: "success",
            autoClose: 3000,
          });
          setIsDisable(false);
          currentTab(1);
        } else {
          toast("Unable to submit. Some error occurred", {
            type: "error",
            autoClose: 3000,
          });
        }
      } catch (err) {
        toast(err?.response?.data?.metadata?.errorMessage, {
          type: "error",
          autoClose: 3000,
        });
      }
    }

  };

  let fetchInitial = async (patientId = "") => {
    if (patientId || id) {
    try {
      const URL = window.location.pathname === route ? `${baseUrl}/openAccess/${id}` : `${baseUrl}/patients/${patientId}`
      const response = await _axios.get(URL);
      if (response.status === 200) {
        // TODO pankaj, remove all irrelevant set messages and use toast message
        setMessage("User created successfully");
      } else {
        setMessage("Some error occured");
      }
      return response.data?.payload?.patientInfo;
    } catch (err) {
      toast.error("Error fetching patient details");
    }
    }
  };

  const setPatientValues = (patient) => {
    const formPayload = { ...patient, patientId: patient?._id }
    setFormValues(mapAPIDataToFormData(formPayload));
    setSelectedRadio(
      "language",
      patient.languages ? patient.languages[0] != "Speaks English"
        ? "prefers"
        : patient.languages[0]
        : ""
    );
  };
  const formattedDates = (date)=>{
    if(date){
      const formattedDate = new Date(date).toISOString().split('T')[0];
      return formattedDate
    }
    else {
      return null
    }
  }

  const mapAPIDataToFormData = (payload) => {
    return {
      patientId: payload.patientId,
      firstName: payload.firstName,
      lastName: payload.lastName,
      claimNumber: payload.claimNumber,
      wcbNumber: payload.wcbNumber,
      dateOfInjury:formattedDates(payload?.dateOfInjury),
      injury: payload.injury,
      dateOfBirth:formattedDates(payload?.dateOfBirth),
      isTranslationRequired:payload.isTranslationRequired,
      isTransportationRequired:payload.isTransportationRequired,
      isRush:payload.isRush,
      gender: payload.gender,
      feet: payload?.height?.feet || "",
      inches: payload?.height?.inches || "",
      weight: payload?.weight || "",
      phone1: payload.phone1 || "",
      mobile: payload.mobile,
      phone3: payload.workPhone || payload.phone3,
      phone4: payload.ext || payload.phone4,
      alternatePhone: payload.alternatePhone,
      alternateDescription: payload.alternateDescription,
      email: payload?.email || "",
      patient_address1: payload.patient_address1,
      patient_address2: payload.patient_address2,
      patient_city: payload.patient_city,
      patient_state: payload.patient_state,
      patient_zip: payload.patient_zip,
      language:
        payload?.languages ? payload?.languages[0] != "Speaks English"
          ? "prefers"
          : payload.languages[0]
          :"",
      preferredLanguage:
        payload?.languages ? payload.languages[0] != "Speaks English"
          ? payload.languages[0]
          : "prefers"
          :"",
    };
  }

  useEffect(() => {
    fetchInitial().then((payload) => {
      if (payload) {
        setPatientValues(payload);
      }
    });
  }, []);

  const handlePhoneChange = (e) => {
    const formattedEvent = formatPhoneNumber(e);
    inputChangeHandler(formattedEvent);
  };

  const formRender=()=>{
    return (
      <form  ref={formRef} className={styles.patientForm} onSubmit={handleSubmit}>
        <div className={styles.header}>
          <Typography.Title className="text-white" level={5}>Patient Information</Typography.Title>
       {
        token &&  <Select
        showSearch
        placeholder="Select a patient"
        optionFilterProp="label"
        // onChange={handlePatientSelect}
        onSearch={handleSearchPatientTextChange}
        filterOption={false}
        style={{width:'50%'}}
        value={selectedPatient ? selectedPatient.label : searchPatientText}
      >
        {searchedPatientsResults.map((patient) => (
          <Option key={patient._id} value={patient._id} label={patient.label}>
          <div onClick={() => handlePatientSelect(patient._id)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>{patient.label}</span>
            <span style={{ fontStyle: 'italic', color: '#888' }}>Claim: {patient.claimNumber || 'N/A'}</span>
          </div>
        </Option>
        ))}
      </Select>
       }
      <br />
      <br />

        </div>
        <div className={styles.formContainerBorder}>
          <NameField
            onChange={(e) => inputChangeHandler(e)}
            formValues={formValues}
            disabled={false}
            errors={errors}
          />
          <div className={styles.formContainer}>
          <Row gutter={16} className={styles.gridContainer}>
          <Col xs={24} lg={12}>
                <Form.Item
                 required
                layout="vertical"
                label="Claim Number"
                htmlFor="claimNumber"
                validateStatus={errors?.claimNumber ? 'error' : ''}
                help={errors?.claimNumber}
                 >
                <Input
                  size="large"
                  className={styles.inpuFields}
                  fullWidth
                  placeholder="Claim Number"
                  id="claimNumber"
                  name="claimNumber"
                  value={formValues.claimNumber}
                  onChange={(e) => inputChangeHandler(e)}
                />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item layout="vertical" label="wcbNumber"
                validateStatus={errors?.wcbNumber ? 'error' : ''}
                help={errors?.wcbNumber}
                required
                >
                <Input
                  size="large"
                  className={styles.inpuFields}
                  fullWidth
                  placeholder="WCB Number"
                  id="wcbNumber"
                  name="wcbNumber"
                  value={formValues.wcbNumber}
                  onChange={(e) => inputChangeHandler(e)}
                />
                </Form.Item>
              </Col>
              <Col xs={24} lg={6}>
                <Form.Item layout="vertical" label="Date Of Injury" className={styles.inpuLabels} htmlFor="date"
                validateStatus={errors?.dateOfInjury ? 'error' : ''}
                help={errors?.dateOfInjury}
                required
                >
                <Input
                  size="large"
                  type="date"
                  fullWidth
                  name="dateOfInjury"
                  placeholder="Last Name"
                  onChange={(e) => inputChangeHandler(e)}
                  value={formValues.dateOfInjury}
                  id="date"
                />
                </Form.Item>
              </Col>

              <Col xs={20} lg={6}>
              <Form.Item label="Injury/Jurisdiction State" layout="vertical" required validateStatus={errors?.injury ? 'error' :''} help={errors?.injury} className={styles.inpuLabels}>
               <Select
                showSearch
                placeholder="Select a state"
                labelId="injury"
                id="injury"
                name="injury"
                value={formValues.injury}
                label="Insurance Company"
                onChange={(value)=>inputChangeHandlerForSelect("injury",value)}
                size="large"
                className="fullWidth"
                filterOption={(input, option) =>
                  option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                }
              >
                  <Option key="0" value="">--Select--</Option>
                {
                 US_STATES.map((state) => {
                   return (
                   <Option key={state?.id} value={state?.name} name={state?.name}>{state?.name}</Option>
                        );
                    })
                }
                   </Select>
              </Form.Item>

              </Col>

              <Col xs={24} lg={12}>
                <Form.Item
                  className="inputLabels"
                  label="Gender"
                  layout="vertical"
                  validateStatus={errors?.gender ? 'error' : ''}
                  help={errors?.gender}
                  required
                >
                  <Radio.Group
                    name="gender"
                    value={formValues.gender}
                    onChange={inputChangeHandler}
                  >
                    <Radio value="female">Female</Radio>
                    <Radio value="male">Male</Radio>
                    <Radio value="X">X</Radio>
                    <Radio value="Unknown">Unknown</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className={styles.formContainer}>
          <Row gutter={16} className={styles.gridContainer}>
              <Col xs={24} lg={6}>
                <Form.Item label="Date Of Birth" layout="vertical" className={styles.inpuLabels} htmlFor="dateOfBirth"
                validateStatus={errors?.dateOfBirth ? 'error' : ''}
                help={errors?.dateOfBirth}
                required
                >
                <Input
                  size="large"
                  type="date"
                  fullWidth
                  placeholder="Date Of Birth"
                  onChange={(e) => inputChangeHandler(e)}
                  id="dateOfBirth"
                  name="dateOfBirth"
                  value={formValues.dateOfBirth}
                />
                </Form.Item>
              </Col>
              <Col xs={24} lg={6}>
                <Form.Item label="Height (Feet Inches)" layout="vertical" className={styles.inpuLabels}>
                <div className={styles.feetInchesSection}>
                  <Input
                    size="large"
                    type="number"
                    fullWidth
                    placeholder="Feet"
                    onChange={(e) => inputChangeHandler(e)}
                    name="feet"
                    id="feet"
                    value={formValues?.feet}
                  />
                  <Input
                    size="large"
                    type="number"
                    fullWidth
                    placeholder="Inches"
                    onChange={(e) => inputChangeHandler(e)}
                    name="inches"
                    id="inches"
                    value={formValues.inches}
                  />
                </div>
                </Form.Item>
              </Col>
              <Col xs={24} lg={6}>
                <Form.Item layout="vertical" label="Weight (lbs)"  className={styles.inpuLabels}
                validateStatus={errors?.weight ? 'error' : ''}
                help={errors?.weight}
                >
                <Input
                  size="large"
                  type="number"
                  fullWidth
                  placeholder="Weight (lbs)"
                  name="weight"
                  onChange={(e) => inputChangeHandler(e)}
                  id="weight"
                  value={formValues.weight}
                />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <ContactsFields
            onChange={(e) => inputChangeHandler(e)}
            formValues={formValues}
            isFax={false}
            isHomePhone={true}
            isCellPhone={true}
            isEmail={true}
            isWorkPhone={true}
            isExt={true}
            isLabel={false}
            errors={errors}
          />
          <div className={styles.formContainer}>
          <Row gutter={16} className={styles.gridContainer}>
              <Col xs={24} lg={6}>
                <Form.Item
                  className={styles.inpuLabels}
                  htmlFor="alternatePhone"
                  label="Alternate Phone"
                  layout="vertical"
                  validateStatus={errors?.alternatePhone ? 'error' : ''}
                  help={errors?.alternatePhone}
                >
                 <Input
                  size="large"
                  fullWidth
                  placeholder="Alternate Phone"
                  name="alternatePhone"
                  onChange={handlePhoneChange}
                  id="alternatePhone"
                  value={formValues.alternatePhone}
                  maxLength={12}
                />
              </Form.Item>
              </Col>
              <Col xs={24} lg={6}>
                <Form.Item
                  className={styles.inpuLabels}
                  htmlFor="alternateDescription"
                  validateStatus={errors?.alternateDescription ? 'error' : ''}
                  help={errors?.alternateDescription}
                >
                  Alt. Phone Description
                <Input
                  size="large"
                  fullWidth
                  placeholder="Alt. Phone Description"
                  name="alternateDescription"
                  onChange={(e) => inputChangeHandler(e)}
                  id="alternateDescription"
                  value={formValues.alternateDescription}
                  validateStatus={errors?.alternateDescription ? 'error' : ''}
                  help={errors?.alternateDescription}
                />
                </Form.Item>
              </Col>
              <Col xs={24} lg={6}>
              </Col>
            </Row>
          </div>
          <FullAddressField
            onChange={(e) => inputChangeHandler(e)}
            formValues={formValues}
            disabled={false}
            isForm = {true}
            errors={errors}
            prefix="patient_"
          />
          <AddressField
            onChange={(e) => inputChangeHandler(e)}
            formValues={formValues}
            disabled={false}
            isForm = {true}
            errors={errors}
            prefix="patient_"
          />
          <div className={styles.formContainer}>
             <Row gutter={16}>
              <Col xs={24} lg={12}>
                <Form.Item
                  label="Languages"
                  className="inputLabels"
                  layout="vertical"
                  validateStatus={errors?.language ? 'error' : ''}
                  help={errors?.language}
                  required
                >
                  <Radio.Group
                    name="language"
                    value={formValues.language}
                    defaultValue="Speaks English"
                    onChange={HandleChangeValue}
                  >
                    <Radio className="inputLabels" value="Speaks English">Speaks English</Radio>
                    <Radio className="inputLabels" value="prefers">Limited English, Prefers</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item
                  label="Prefers"
                  className="inputLabels"
                  layout="vertical"
                >
                  <Input
                    size="large"
                    placeholder="Preferred Language"
                    id="preferredLanguage"
                    onChange={inputChangeHandler}
                    name="preferredLanguage"
                    disabled={formValues.language !== "prefers"}
                    value={formValues.preferredLanguage}
                  />
                </Form.Item>
              </Col>
            </Row>
            </div>
            <div className={styles.formContainer}>
            <Row gutter={16}>
          <Col xs={24} lg={12}>
                <Form.Item
                  label="Support Services"
                  layout="vertical"
                  className="inputLabels"
                >
                  <div className="extraOptions">
                    <Checkbox
                      name="isTranslationRequired"
                      checked={formValues.isTranslationRequired}
                      value={formValues.isTranslationRequired}
                      onChange={(e) => CheckboxChangeHandler("isTranslationRequired", e)}
                      className="inputLabels"
                    >
                      Translation Needed
                    </Checkbox>
                    <Checkbox
                      name="isTransportationRequired"
                      value={formValues.isTransportationRequired}
                      checked={formValues.isTransportationRequired}
                      onChange={(e) => CheckboxChangeHandler("isTransportationRequired", e)}
                      className="inputLabels"
                    >
                      Transportation Needed
                    </Checkbox>
                  </div>
                </Form.Item>
              </Col>
              <Col xs={24} lg={6}>
              <Form.Item
                label="Rush Processing"
                layout="vertical"
                className="inputLabels"
              >
                <div className="extraOptions">
                  <Checkbox
                    name="isRush"
                    value={formValues.isRush}
                    checked={formValues.isRush}
                    onChange={(e) => CheckboxChangeHandler("isRush", e)}
                    className="inputLabels"
                  >
                    Rush
                  </Checkbox>
                </div>
              </Form.Item>
          </Col>
            </Row>
          </div>
          <Row gutter={16} className={styles.gridContainer}>
            <Col xs={24} lg={12}></Col>
            <Col className={styles.patientBtn} xs={24} lg={12}>
              <FormButtons isDisable={isDisable}/>
            </Col>
          </Row>
        </div>
      </form>
    )
  }

  return (
    <Content className={styles.formsWrapper}>
      {formRender()}
    </Content>
  );
};
export default PatientForm;
